/**
 * @file index.tsx
 * @fileoverview Renders the BreadcrumbList schema.org.
 */
import { useContext } from 'react';
import { JsonLd } from 'react-schemaorg';
import { BreadcrumbList } from 'schema-dts';
import { Breadcrumb } from '~/jobiqo/components/Breadcrumbs';
import { PathContext } from '~/jobiqo/context/app';

interface BreadcrumbsSchemaProps {
  /**
   * The schema items list.
   */
  items: Breadcrumb[];
}

export default function BreadcrumbsSchema({ items }: BreadcrumbsSchemaProps) {
  const { host } = useContext(PathContext);

  return (
    <JsonLd<BreadcrumbList>
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map(({ label, path }, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: label,
          item: `${host}${path}`,
        })),
      }}
    />
  );
}
export { BreadcrumbsSchema };
